import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../../components/layout/SiteLayout";
import PageIntro from "../../components/ui/PageIntro";
import { FaArrowRight } from "react-icons/fa";

const employment = [
  {
    company: "Intuit",
    role: "Staff Software Engineer",
    duration: "Mar 2026 - Present",
    summary:
      "I recently joined Intuit to help design and develop the greenfield digital assets platform for peer-to-peer stablecoin transfer, with work across Java, PostgreSQL, React, and distributed microservices.",
    bullets: [],
  },
  {
    company: "Goldman Sachs",
    role: "Vice President / Lead Software Engineer",
    duration: "Dec 2019 - Mar 2026",
    bullets: [
      "Technical lead for RFQ/RFT, trade booking, and risk platforms supporting high-volume front-office trading workflows with strict availability and latency requirements.",
      "Owned architecture and delivery of highly available, low-latency distributed microservices using Java, event-driven messaging, and in-memory designs for real-time workflows.",
      "Led FIX-based integrations with external venues, ensuring throughput, reliability, and regulatory correctness.",
      "Drove UI modernization of trading and booking applications in React, improving trader efficiency and time-to-action.",
      "Led cross-team initiatives across Trading, Risk, Sales, and Operations from design through production.",
      "Built AI-powered workflows using LLMs and prompt engineering to parse and summarize legal contracts with validation checks for reliable production outputs.",
      "Used AI agentic LLM workflows and GitHub Copilot to accelerate feature delivery, refactoring, and test generation while maintaining production quality.",
    ],
  },
  {
    company: "The Princeton Review",
    role: "Senior Software Engineer",
    duration: "Jan 2015 - Nov 2019",
    bullets: [
      "Led development of a large-scale Student Dashboard and exam simulation platform.",
      "Built backend services and MVC applications in C# and SQL Server supporting personalized learning workflows.",
      "Designed a recommendation engine to suggest coursework based on exam performance.",
      "Delivered real-time messaging between students and advisors, and internal admin tooling for content management.",
    ],
  },
  {
    company: "Insight Catastrophe Group",
    role: "Software Engineer",
    duration: "Mar 2014 - Dec 2014",
    logo: "data:image/png;base64,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",
    logoWidth: 180,
    bullets: [
      "Developed cloud-based risk management microservices using C# and Web API.",
      "Built administrative interfaces for configuring catastrophe risk models.",
    ],
  },
  {
    company: "SRS Soft",
    role: "Software Engineer",
    duration: "Apr 2011 - Mar 2014",
    logo: "https://healthitdirectory.com/wp-content/uploads/logos/free/Srssoft.jpg",
    logoWidth: 180,
    bullets: [
      "Designed scalable, multi-threaded patient data routing services handling secure healthcare data flows.",
      "Built RESTful APIs and healthcare web applications using C#, ASP.NET, JavaScript, and SQL.",
      "Contributed reusable JavaScript UI components as part of the Core UI Committee.",
    ],
  },
];

const education = [
  {
    school: "Pace University",
    degree: "M.S. Software Development & Engineering",
    year: "2014",
    logo: "https://upload.wikimedia.org/wikipedia/commons/d/d4/Pace_University_Logo.svg",
  },
  {
    school: "St. John's University",
    degree: "B.S. Computer Science, Networking and Telecommunication",
    year: "2010",
    logo: "https://www.stjohns.edu/sites/default/files/alumni-feature-sju-brand_0.jpg",
  },
];

const skillSections = [
  {
    title: "Core",
    items: [
      "Distributed systems",
      "Low-latency services",
      "Event-driven architecture",
      "System design",
    ],
  },
  {
    title: "Languages",
    items: ["Java", "C#", "JavaScript", "SQL", "Python", "C++"],
  },
  {
    title: "Frontend",
    items: ["React", "TypeScript", "Angular", "jQuery"],
  },
  {
    title: "Backend & Platforms",
    items: [
      ".NET / ASP.NET",
      "Web API",
      "Kafka",
      "Kubernetes",
      "AWS (EC2, S3)",
    ],
  },
  {
    title: "Observability",
    items: ["Prometheus", "Grafana", "Kibana", "Splunk"],
  },
  {
    title: "Developer Productivity",
    items: [
      "GitHub Copilot",
      "AI-assisted coding workflows",
      "Agentic LLM-based workflows",
    ],
  },
];

function BrandLogo({ src, alt, width }) {
  const [failed, setFailed] = React.useState(false);

  if (failed) {
    return (
      <div className="brand-logo-fallback" aria-label={alt}>
        {alt}
      </div>
    );
  }

  return (
    <img
      className="brand-logo-image"
      src={src}
      width={width}
      alt={alt}
      onError={() => setFailed(true)}
    />
  );
}

export default class ResumePage extends React.Component {
  render() {
    return (
      <SiteLayout>
        <main className="page-shell">
          <PageIntro
            eyebrow="Professional"
            title="Lead engineering work."
            description="I build and own distributed systems, trading platforms, and workflow tools with a technical lead mindset."
            actions={[
              { label: "Email", href: "mailto:vishwaramm@gmail.com", external: true, variant: "primary" },
              { label: "Phone", href: "tel:9144142079", external: true, variant: "secondary" },
            ]}
            image={{ src: `${process.env.PUBLIC_URL}/assets/main-portrait.png` }}
          />

          <section className="section">
            <div className="home-v3-band-label">
              <span className="home-v3-kicker">Professional Summary</span>
              <h2>What I focus on.</h2>
              <p>
                I work on low-latency systems, trading and risk tools, UI
                modernization, and cross-team delivery in high-stakes
                environments.
              </p>
            </div>
            <div className="glass-card card-pad resume-overview">
              <div className="resume-overview-grid">
                <div className="resume-overview-item">
                  <div className="home-v3-kicker">Most recent role</div>
                  <h3>Intuit</h3>
                  <p>Staff Software Engineer on the Digital Assets Team.</p>
                </div>
                <div className="resume-overview-item">
                  <div className="home-v3-kicker">Recent stack</div>
                  <h3>Java, React, distributed technologies</h3>
                  <p>Digital assets platform work across distributed services and UI delivery.</p>
                </div>
                <div className="resume-overview-item">
                  <div className="home-v3-kicker">Current shape</div>
                  <h3>Lead delivery</h3>
                  <p>Technical ownership across product, platform, and execution.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="section">
            <div className="home-v3-band-label">
              <span className="home-v3-kicker">Employment</span>
              <h2>Where I worked.</h2>
              <p>
                I order these roles by impact and ownership, with the current
                role first and previous roles below.
              </p>
            </div>
            <div className="glass-card card-pad work-history">
              {employment.map((job) => (
                <article
                  className={`work-item${job.current ? " is-current" : ""}`}
                  key={`${job.company}-${job.role}`}
                >
                  <div className="work-item-rail">
                    <h3 className="feature-title work-company">
                      {job.company}
                    </h3>
                    <div className="home-v3-kicker timeline-role">{job.role}</div>
                  </div>
                  <div className="work-item-body">
                    {job.summary ? <p className="work-summary">{job.summary}</p> : null}
                    {job.bullets.length > 0 ? (
                      <div className="details work-details">
                        <ul>
                          {job.bullets.map((bullet) => (
                            <li key={bullet}>{bullet}</li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                    <div className="home-v3-kicker work-duration">
                      {job.duration}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="section">
            <div className="home-v3-band-label">
              <span className="home-v3-kicker">Education</span>
              <h2>Academic foundation.</h2>
              <p>
                Degrees and programs that shaped my engineering base.
              </p>
            </div>
            <div className="glass-card card-pad">
              <div className="resume-row-list">
                {education.map((item) => (
                  <article className="resume-row" key={item.school}>
                    <div className="resume-row-brand">
                      <BrandLogo
                        src={item.logo}
                        alt={item.school}
                        width={160}
                      />
                    </div>
                    <div className="resume-row-body">
                      <h3 className="feature-title">{item.degree}</h3>
                      <p className="meta-copy">{item.school}</p>
                    </div>
                    <div className="home-v3-kicker resume-row-meta">{item.year}</div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          <section className="section">
            <div className="home-v3-band-label">
              <span className="home-v3-kicker">Languages & Technologies</span>
              <h2>Tools I use in real systems.</h2>
              <p>
                I work on low-latency systems, trading and risk tools, UI
                I keep this list to the technical skills I use in production
                systems, delivery tooling, and platform work.
              </p>
            </div>
            <div className="glass-card card-pad">
              <div className="resume-skill-list">
                {skillSections.map((section) => (
                  <article className="resume-skill-row" key={section.title}>
                    <div className="resume-skill-title">
                      <div className="home-v3-kicker">{section.title}</div>
                    </div>
                    <div className="pill-list resume-skill-pills">
                      {section.items.map((item) => (
                        <span className="pill" key={item}>
                          {item}
                        </span>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
              <div className="hero-actions">
                <Link className="button-secondary" to="/professional/projects">
                  See Projects <FaArrowRight />
                </Link>
              </div>
            </div>
          </section>
        </main>
      </SiteLayout>
    );
  }
}
